/**
 * HTTP-aware error class that carries the response status code.
 * Used by hydration fetches so the retry predicate can distinguish
 * transient (5xx / 429) from non-transient (4xx) failures.
 */
export class HttpError extends Error {
  readonly status: number

  constructor(message: string, status: number) {
    super(message)
    this.name = 'HttpError'
    this.status = status
  }
}

/**
 * Returns true when the error represents a transient failure that
 * is worth retrying (server errors, rate-limits, network failures).
 * Returns false for non-transient cases (4xx, JSON parse errors,
 * AbortError, etc.) so they surface immediately.
 */
export function isTransientError(error: unknown): boolean {
  if (error instanceof HttpError) {
    return error.status >= 500 || error.status === 429
  }
  // Network errors (e.g. TypeError from fetch) are transient
  if (error instanceof TypeError) {
    return true
  }
  // Unknown error types are not retried
  return false
}
